import { selectorFamily } from 'recoil';
import { apiClientState } from './api';
import { tokensState } from './auth';

export const applicationInfoQuery = selectorFamily({
	key: 'applicationInfo',
	get: (app_id: string) => async ({ get }) => {
		if (typeof app_id !== 'string')
			throw new Error('Invalid Application ID');
		const apiClient = get(apiClientState);
		const tokens = get(tokensState);

		return await apiClient.readApp(tokens, { app_id });
	},
});
